import { FormField, QuestionnaireDescription, SwitchField } from "common";
import { useField } from "formik";
import { noop } from "lodash";
import React from "react";
import { FieldProps } from "./TextField";

export const CheckboxField = ({ name, field, classNames, showDescription = true, onChange }: FieldProps) => {
    const [props, , helpers] = useField(name);

    return (
        <FormField name={name} label={field.label} classNames={{ label: classNames?.label }}>
            {showDescription && <QuestionnaireDescription field={field} />}
            <SwitchField
                isChecked={
                    props.value === "1" || props.value === "Yes" || (typeof props.value !== "string" && !!props.value)
                }
                onChange={(value) => {
                    helpers.setValue(value ? "1" : "");
                    onChange ? onChange(value) : noop();
                }}
            >
                {field.label}
            </SwitchField>
        </FormField>
    );
};
